(function () {
  var ratingHints = {
    1: 'Nicht hilfreich',
    2: 'Wenig hilfreich',
    3: 'Ganz okay',
    4: 'Hilfreich',
    5: 'Sehr hilfreich'
  };

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function starText(value) {
    var rating = Math.max(0, Math.min(5, Math.round(Number(value || 0))));
    return '★★★★★'.slice(0, rating) + '☆☆☆☆☆'.slice(0, 5 - rating);
  }

  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function endpoint(root, path) {
    return String(root.dataset.endpoint || '/apps/content-feedback').replace(/\/+$/, '') + path;
  }

  function contentType(root) {
    return root.dataset.contentType || 'page';
  }

  function contentReference(root) {
    return root.dataset.contentReference || '';
  }

  function targetQuery(root) {
    return 'content_type=' + encodeURIComponent(contentType(root)) + '&content_reference=' + encodeURIComponent(contentReference(root));
  }

  function setError(root, message) {
    var box = root.querySelector('[data-cs-feedback-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function renderPublicEmptyState(root) {
    renderSummaryCard(root, { count: 0, average_rating: 0 }, 0);
    renderComments(root, []);
  }

  function requestJson(url, options) {
    options = options || {};
    if (typeof window.fetch === 'function') {
      return window.fetch(url, {
        method: options.method || 'GET',
        headers: options.headers || { Accept: 'application/json' },
        body: options.body
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          var output = {};
          output.ok = response.ok;
          output.payload = payload;
          return output;
        });
      });
    }
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      var headers = options.headers || { Accept: 'application/json' };
      Object.keys(headers).forEach(function (key) {
        xhr.setRequestHeader(key, headers[key]);
      });
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        var payload = {};
        try {
          payload = xhr.responseText ? JSON.parse(xhr.responseText) : {};
        } catch (parseError) {
          payload = {};
        }
        var output = {};
        output.ok = xhr.status >= 200 && xhr.status < 300;
        output.payload = payload;
        resolve(output);
      };
      xhr.onerror = function () { reject(new Error('Feedback konnte nicht geladen werden.')); };
      xhr.send(options.body || null);
    });
  }

  function updateStarState(stars, value, preview) {
    var rating = Number(value || 0);
    stars.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      var starValue = Number(input && input.value);
      label.classList.toggle(preview ? 'is-preview' : 'is-active', Boolean(rating && starValue <= rating));
      if (!preview) label.classList.remove('is-preview');
    });
    var hint = stars.closest('fieldset') && stars.closest('fieldset').querySelector('[data-cs-feedback-rating-hint]');
    if (hint) {
      hint.textContent = rating
        ? rating + ' von 5 Sternen - ' + ratingHints[rating]
        : 'Wähle 1 bis 5 Sterne.';
    }
  }

  function selectedRating(stars) {
    var checked = stars.querySelector('input:checked');
    return checked ? checked.value : '';
  }

  function initStarControls(root) {
    var stars = root.querySelector('[data-cs-feedback-rating]');
    if (!stars || stars.dataset.ready) return;
    stars.dataset.ready = 'true';
    stars.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      label.addEventListener('mouseenter', function () { updateStarState(stars, input.value, true); });
      label.addEventListener('mouseleave', function () { updateStarState(stars, selectedRating(stars), false); });
      input.addEventListener('focus', function () { updateStarState(stars, input.value, true); });
      input.addEventListener('blur', function () { updateStarState(stars, selectedRating(stars), false); });
      input.addEventListener('change', function () { updateStarState(stars, input.value, false); });
    });
    updateStarState(stars, selectedRating(stars), false);
  }

  function renderSummaryCard(root, summary, commentCount) {
    var score = root.querySelector('[data-cs-feedback-score]');
    if (!score) return;
    var count = Number(summary.count || 0);
    var average = Number(summary.average_rating || 0);
    if (!count) {
      score.innerHTML = [
        '<span class="cs-content-feedback__score-label">Feedback-Status</span>',
        '<strong>Noch kein Feedback vorhanden</strong>',
        '<span>Sei der Erste mit deiner Einschätzung zu diesem Beitrag.</span>'
      ].join('');
      return;
    }
    score.innerHTML = [
      '<span class="cs-content-feedback__score-label">Feedback-Status</span>',
      '<strong>' + average.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' von 5</strong>',
      '<span class="cs-content-feedback__score-stars" aria-label="' + escapeHtml(average + ' von 5 Sternen') + '">' + starText(average) + '</span>',
      '<div class="cs-content-feedback__score-meta">',
      '<span>' + count + ' Bewertung' + (count === 1 ? '' : 'en') + '</span>',
      '<span>' + commentCount + ' freigegebene' + (commentCount === 1 ? 'r Kommentar' : ' Kommentare') + '</span>',
      '</div>'
    ].join('');
  }

  function commentHtml(item) {
    var date = formatDate(item.updated_at);
    var author = item.display_name || 'Community-Mitglied';
    return [
      '<article class="cs-content-feedback__comment">',
      '<div class="cs-content-feedback__comment-head">',
      '<div class="cs-content-feedback__author">',
      '<strong>' + escapeHtml(author) + '</strong>',
      '<span class="cs-content-feedback__badge">Mitglied</span>',
      '</div>',
      '<div class="cs-content-feedback__comment-meta">',
      '<span class="cs-content-feedback__comment-stars" aria-label="' + escapeHtml(item.rating + ' von 5 Sternen') + '">' + starText(item.rating) + '</span>',
      date ? '<span>' + escapeHtml(date) + '</span>' : '',
      '</div>',
      '</div>',
      '<p>' + escapeHtml(item.comment) + '</p>',
      '</article>'
    ].join('');
  }

  function renderComments(root, rows) {
    var comments = root.querySelector('[data-cs-feedback-comments]');
    var countLabel = root.querySelector('[data-cs-feedback-comment-count]');
    if (countLabel) {
      countLabel.textContent = rows.length
        ? rows.length + ' freigegebene' + (rows.length === 1 ? 'r Kommentar' : ' Kommentare')
        : 'Noch kein öffentlicher Kommentar';
    }
    if (!comments) return;
    if (!rows.length) {
      comments.innerHTML = [
        '<div class="cs-content-feedback__empty">',
        '<strong>Noch kein Community-Feedback vorhanden.</strong>',
        '<p>Teile als Erster deine Einschätzung: Hat dir der Beitrag geholfen oder fehlt aus deiner Sicht noch etwas?</p>',
        '</div>'
      ].join('');
      return;
    }
    var visibleCount = Number(root.dataset.visibleComments || 3);
    var visibleRows = rows.slice(0, visibleCount);
    comments.innerHTML = visibleRows.map(commentHtml).join('') + (
      rows.length > visibleCount
        ? '<button class="cs-content-feedback__more" type="button" data-cs-feedback-more>Weitere Kommentare anzeigen</button>'
        : ''
    );
  }

  function renderViewerState(root, payload) {
    var form = root.querySelector('[data-cs-feedback-form]');
    var viewer = root.querySelector('[data-cs-feedback-viewer]');
    var submit = root.querySelector('[data-cs-feedback-submit]');
    var title = root.querySelector('[data-cs-feedback-form-title]');
    if (!form) return;
    if (!payload.viewer_feedback) {
      if (viewer) viewer.hidden = true;
      if (submit) submit.textContent = 'Feedback absenden';
      if (title) title.textContent = 'Dein Feedback';
      return;
    }
    var input = form.querySelector('[name="rating"][value="' + payload.viewer_feedback.rating + '"]');
    if (input) input.checked = true;
    var textarea = form.querySelector('[name="comment"]');
    if (textarea) textarea.value = payload.viewer_feedback.comment || '';
    var stars = root.querySelector('[data-cs-feedback-rating]');
    if (stars) updateStarState(stars, payload.viewer_feedback.rating, false);
    if (submit) submit.textContent = 'Feedback aktualisieren';
    if (title) title.textContent = 'Dein Feedback aktualisieren';
    if (viewer) {
      var status = payload.viewer_feedback.moderation_status;
      var message = status === 'pending'
        ? 'Danke für dein Feedback. Kommentare werden vor der Veröffentlichung kurz geprüft.'
        : status === 'approved'
          ? 'Dein Kommentar ist freigegeben und öffentlich sichtbar.'
          : 'Dein vorheriger Kommentar wurde nicht veröffentlicht. Du kannst dein Feedback aktualisieren.';
      viewer.textContent = message;
      viewer.hidden = false;
    }
  }

  function renderSummary(root, payload) {
    var form = root.querySelector('[data-cs-feedback-form]');
    var login = root.querySelector('[data-cs-feedback-login]');
    var summary = payload.summary || {};
    var rows = Array.isArray(payload.comments) ? payload.comments : [];
    renderSummaryCard(root, summary, rows.length);
    renderComments(root, rows);
    if (form) form.hidden = !payload.customer_logged_in;
    if (login) login.hidden = Boolean(payload.customer_logged_in);
    renderViewerState(root, payload);
  }

  function shouldScrollToFeedback(root) {
    var params = new URLSearchParams(window.location.search || '');
    return window.location.hash === '#cs-content-feedback'
      || params.get('cs_feedback') === '1'
      || root.dataset.scrollAfterLogin === 'true';
  }

  function scrollToFeedback(root) {
    if (root.dataset.didFeedbackScroll === 'true' || !shouldScrollToFeedback(root)) return;
    root.dataset.didFeedbackScroll = 'true';
    window.setTimeout(function () {
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var form = root.querySelector('[data-cs-feedback-form]:not([hidden])');
      var target = form && (form.querySelector('input[name="rating"]') || form.querySelector('textarea') || form.querySelector('button'));
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }, 220);
  }

  function load(root) {
    return requestJson(endpoint(root, '/summary?' + targetQuery(root)), { headers: { Accept: 'application/json' } })
      .then(function (result) {
        var payload = result.payload || {};
        if (!result.ok || !payload.ok) throw new Error(payload.error || 'Feedback konnte nicht geladen werden.');
        root.__csFeedbackPayload = payload;
        renderSummary(root, payload);
        scrollToFeedback(root);
      });
  }

  function submit(root, form) {
    var formData = new FormData(form);
    var body = {
      content_type: root.dataset.contentType || 'page',
      content_reference: root.dataset.contentReference || '',
      rating: formData.get('rating'),
      comment: formData.get('comment') || ''
    };
    return requestJson(endpoint(root, '/feedback?' + targetQuery(root)), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (result) {
      var payload = result.payload || {};
      if (!result.ok || !payload.ok) throw new Error(payload.error || 'Feedback konnte nicht gespeichert werden.');
      var nextPayload = payload.public_summary || payload;
      root.__csFeedbackPayload = nextPayload;
      renderSummary(root, nextPayload);
      setError(root, '');
    });
  }

  document.querySelectorAll('[data-cs-content-feedback]').forEach(function (root) {
    initStarControls(root);
    load(root).catch(function () {
      renderPublicEmptyState(root);
      scrollToFeedback(root);
    });
    var form = root.querySelector('[data-cs-feedback-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        submit(root, form)
          .catch(function (error) { setError(root, error.message); })
          .finally(function () { if (button) button.disabled = false; });
      });
    }
    root.addEventListener('click', function (event) {
      var more = event.target.closest && event.target.closest('[data-cs-feedback-more]');
      if (!more || !root.__csFeedbackPayload) return;
      root.dataset.visibleComments = String(Number(root.dataset.visibleComments || 3) + 3);
      renderComments(root, Array.isArray(root.__csFeedbackPayload.comments) ? root.__csFeedbackPayload.comments : []);
    });
  });
})();
